/** Opción del combo; el id sigue el API de usuarios (camelCase userId). */
export interface DriverLinkableAppUser {
    userId: string;
    firstName: string;
    lastName: string;
    email?: string;
}

export class Driver {
    DriverID: number
    LastName: string
    FirstName: string
    /** Id del usuario de login (Identity); en JSON del PATCH va como UserId (PascalCase). */
    UserId?: string | null
    Addr1: string
    Addr2: string
    ZipCode: string
    Active: boolean

    HomePhoneAreaCode: string
    HomePhonePrefix: string
    HomePhoneSuffix: string
    PagerAreaCode: string
    PagerPrefix: string
    PagerSuffix: string
    LastActivity: string

    DriverLicenseNumber: string            
    DriverLicenseExpDate: string
    MedicalCardExpDate: string
    VehicleRegistrationExpDate: string
    VehicleInspection90DayExpDate: string
    W9OnFileFlag: boolean
    ContractOnFileFlag: boolean
    ApplicationOnFileFlag: boolean
    Comments: string
    RadioSuppliedFlag: boolean
    InsuranceSuppliedFlag: boolean
    RadioNumber: string
    name_on_check: string
    TruckNumber: string
    /** Código de cuenta contable en QuickBooks (vendor/expense account) para asientos de pago al driver. */
    QuickBooksAccountCode?: string | null

    insurance_amt: number
    pager_amt: number
    wcomp_amt: number
    email: string
    misc_amt: number
    misc_desc: string
    InsuranceCompany: string
    InsuranceNumber: string
    insuranceExpDate: string
    MessageDomain: string
    CompanyDriverFlag: boolean
    CompanyDriverPayPercent: number
    stateID: string
    CityID: number
    city: string
    state: string

    readOnly: boolean;

    constructor() {
        this.DriverID = null;
        this.FirstName = null;
        this.LastName = null;
        this.stateID = null;
        this.CityID = null;
        this.insuranceExpDate = null;
        this.DriverLicenseExpDate = null;
        this.MedicalCardExpDate = null;
        this.VehicleRegistrationExpDate = null;
        this.VehicleInspection90DayExpDate = null;
        this.Active = true;
        this.TruckNumber = null;
        this.UserId = null;
        this.QuickBooksAccountCode = null;
    }

}

export class DriverCatalog {
    DriverID: number
    LastName: string
    FirstName: string
    Selected: boolean
    QuickBooksAccountCode?: string | null

    constructor(
        driverID: number,
        lastName: string,
        firstName: string,
        selected: boolean,
        quickBooksAccountCode?: string | null,
    ) {
        this.DriverID = driverID;
        this.FirstName = lastName;
        this.LastName = firstName;
        this.Selected = selected;
        this.QuickBooksAccountCode = quickBooksAccountCode ?? null;
    }
}
